/** Extract human-readable messages from a DRF/axios error response. */
export function formatApiError(err: unknown, fallback: string): string {
  const data = (err as { response?: { data?: Record<string, unknown> } })?.response?.data;
  if (!data) {
    return fallback;
  }

  if (typeof data.error === 'string') {
    return data.error;
  }

  if (typeof data.detail === 'string') {
    return data.detail;
  }

  const messages: string[] = [];

  const append = (value: unknown) => {
    if (Array.isArray(value)) {
      value.forEach((item) => append(item));
    } else if (value != null && value !== '') {
      messages.push(String(value));
    }
  };

  append(data.non_field_errors);
  append(data.new_password);
  append(data.new_password_confirm);
  append(data.old_password);
  append(data.password);
  append(data.password_confirm);
  append(data.username);
  append(data.first_name);
  append(data.last_name);
  append(data.hourly_rate);
  append(data.effective_date);
  append(data.sick_hours);

  return messages.length > 0 ? messages.join(' ') : fallback;
}

export const PASSWORD_REQUIREMENTS_HINT =
  'Use at least 8 characters. Avoid common passwords and making it too similar to your username.';
